import { FeedCreateScreen } from "../screens/applications/products/feed/FeedCreateScreen";
import { FeedListScreen } from "../screens/applications/products/feed/FeedListScreen";
import { ProductListScreen } from "../screens/applications/products/item/ProductListScreen";
import { ProductOrderItemScreen } from "../screens/applications/products/item/ProductOrderItemScreen";
import { ProductShipmentItemHistoryScreen } from "../screens/applications/products/item/ProductShipmentItemHistoryScreen";
import { ProductReviewScreen } from "../screens/applications/products/review/ProductReviewScreen";
import { SponsorCreateScreen } from "../screens/applications/products/sponsor/SponsorCreateScreen";
import { SponsorDetailScreen } from "../screens/applications/products/sponsor/SponsorDetailScreen";
import { SponsorListScreen } from "../screens/applications/products/sponsor/SponsorListScreen";
import { DiscountListScreen } from "../screens/applications/products/discount/DiscountListScreen";
import { DiscountDetailScreen } from "../screens/applications/products/discount/DiscountDetailScreen";
import { DiscountFormScreen } from "../screens/applications/products/discount/DiscountFormScreen";
import { OrderListScreen } from "../screens/applications/orders/OrderListScreen";
import { AdditionalScreen } from "../screens/applications/products/item/AdditionalScreen";
import { InventoryShipmentScreen } from "../screens/applications/inventories/InventoryShipmentScreen";
import { InventoryShipementDetailScreen } from "../screens/applications/inventories/InventoryShipmentDetailScreen";
import { InventoryShipmentLogScreen } from "../screens/applications/inventories/InventoryShipmentLogScreen";
import { DisbursementLogScreen } from "../screens/applications/disbursements/DisbursementLogScreen";
import { InventorySkuScreen } from "../screens/applications/inventories/InventorySkuScreen";
import { RequestDisbursementScreen } from "../screens/applications/disbursements/RequestDisbursementScreen";
import { DisbursementDetailScreen } from "../screens/applications/disbursements/DisbursementDetailScreen";
import { LoginLessScreen } from "../screens/applications/loginless/LoginLessScreen";
import { MassProductListScreen } from "../screens/applications/products/mass/MassProductListScreen";
import { MassProductDetailScreen } from "../screens/applications/products/mass/MassProductDetailScreen";
import { InventoryTrackingScreen } from "../screens/applications/inventories/InventoryTrackingScreen";
import { AdsCampaignListScreen } from "../screens/applications/products/ads/AdsCampaignListScreen";
import { AdsCampaignScreen } from "../screens/applications/products/ads/AdsCampaignScreen";
import { LoginLessListScreen } from "../screens/applications/loginless/LoginLessListScreen";
import { LoginLessOrderDetailScreen } from "../screens/applications/loginless/LoginLessOrderDetailtScreen";
import { CreateProductChoiceScreen } from "../screens/applications/products/choice/CreateProductChoiceScreen";
import { ProductChoiceScreen } from "../screens/applications/products/choice/ProductChoiceScreen";
import MassProductScreen from "src/pages/product/mass";

export const ApplicationRoutes = [
  { path: "/review", exact: true, component: ProductReviewScreen },
  { path: "/feed", exact: true, component: FeedListScreen },
  { path: "/feed/create", exact: true, component: FeedCreateScreen },
  { path: "/feed/edit/:id", exact: true, component: FeedCreateScreen },
  { path: "/product/additional/:id", exact: true, component: AdditionalScreen },
  { path: "/product/list", exact: true, component: ProductListScreen },
  {
    path: "/product/order/:id",
    exact: true,
    component: ProductOrderItemScreen,
  },
  {
    path: "/product/shipment/:id",
    exact: true,
    component: ProductShipmentItemHistoryScreen,
  },
  { path: "/sponsor/list", exact: true, component: SponsorListScreen },
  { path: "/sponsor/detail/:id", exact: true, component: SponsorDetailScreen },
  { path: "/sponsor/create", exact: true, component: SponsorCreateScreen },
  { path: "/discount/list", exact: true, component: DiscountListScreen },
  {
    path: "/discount/detail/:id",
    exact: true,
    component: DiscountDetailScreen,
  },
  { path: "/discount/create", exact: true, component: DiscountFormScreen },
  { path: "/discount/edit/:id", exact: true, component: DiscountFormScreen },
  { path: "/orders/list", exact: true, component: OrderListScreen },
  { path: "/orders/loginless", exact: true, component: LoginLessListScreen },
  { path: "/orders/loginless/create", exact: true, component: LoginLessScreen },
  {
    path: "/orders/loginless/detail/:id",
    exact: true,
    component: LoginLessOrderDetailScreen,
  },
  {
    path: "/applications/inventories/list",
    exact: true,
    component: InventoryShipmentScreen,
  },
  {
    path: "/applications/inventories/detail/:id",
    exact: true,
    component: InventoryShipementDetailScreen,
  },
  {
    path: "/applications/inventories/log",
    exact: true,
    component: InventoryShipmentLogScreen,
  },
  {
    path: "/applications/inventories/sku",
    exact: true,
    component: InventorySkuScreen,
  },
  {
    path: "/applications/disbursement/log",
    exact: true,
    component: DisbursementLogScreen,
  },
  {
    path: "/applications/disbursement/request",
    exact: true,
    component: RequestDisbursementScreen,
  },
  {
    path: "/applications/disbursement/detail/:id",
    exact: true,
    component: DisbursementDetailScreen,
  },
  { path: "/product/mass", exact: true, component: MassProductScreen },
  { path: "/product/mass/list", exact: true, component: MassProductListScreen },
  {
    path: "/product/mass/detail/:id",
    exact: true,
    component: MassProductDetailScreen,
  },
  {
    path: "/applications/tracking",
    exact: true,
    component: InventoryTrackingScreen,
  },
  { path: "/product/ads/list", exact: true, component: AdsCampaignListScreen },
  { path: "/product/ads/create", exact: true, component: AdsCampaignScreen },
  {
    path: "/product/ads/create/:id",
    exact: true,
    component: AdsCampaignScreen,
  },
  {
    path: "/product/choice/create",
    exact: true,
    component: CreateProductChoiceScreen,
  },
  { path: "/product/choice/list", exact: true, component: ProductChoiceScreen },
];
